import {Trans} from '@lingui/macro';
import React, {FC, useState} from 'react';

import {OnboardingTipTypesEnum} from '../../models/api/preferencesModel';
import {InfoBubble, InfoBubbleInstanceProps} from '../common/infoBubbles/infoBubble';
import {InfoBubbleActionInstruction} from '../common/infoBubbles/infoBubbleActionInstruction';
import {InfoBubbleContent} from '../common/infoBubbles/infoBubbleContent';
import {InfoBubbleTitle} from '../common/infoBubbles/infoBubbleContentTitle';
import {useInfoBubblesContext} from '../common/infoBubbles/infoBubblesContext';

/*
 * Component.
 */

export const GuidedDemoEditDraftInfoBubble: FC<InfoBubbleInstanceProps> = ({targetRef}) => {
  const context = useInfoBubblesContext();

  // State and helpers necessary to animate the action instruction on outside click.
  const [isActionInstructionAnimated, setIsActionInstructionAnimated] = useState<boolean>(false);
  const triggerActionInstructionAnimation = () => {
    setIsActionInstructionAnimated(true);
  };
  const onActionInstructionAnimationEnd = () => {
    setIsActionInstructionAnimated(false);
  };

  return (
    <InfoBubble
      {...context}
      type={OnboardingTipTypesEnum.GUIDED_DEMO_EDIT_DRAFT}
      position="top"
      targetRef={targetRef}
      onOutsideHighlightClick={triggerActionInstructionAnimation}
      isStandalone
      hasHighlightPulse
    >
      <InfoBubbleContent>
        <InfoBubbleTitle>
          <Trans id="infobubble-guideddemoeditdraft-title">Draft a reply with a teammate</Trans>
        </InfoBubbleTitle>
        <Trans id="infobubble-guideddemoeditdraft-description">
          This is a shared draft. Instead of sending changes back and forth, you can work on emails together.
        </Trans>
        <InfoBubbleActionInstruction
          isAnimated={isActionInstructionAnimated}
          onAnimationEnd={onActionInstructionAnimationEnd}
          iconName="draftFilledSmall"
          text={
            <Trans id="infobubble-guideddemoeditdraft-instruction">
              Click &quot;Edit&quot; to take over a draft
            </Trans>
          }
        />
      </InfoBubbleContent>
    </InfoBubble>
  );
};
